<template>
  <div class="flex justify-between items-center mb-5 space-x-6">
    <h2 class="text-black-900 font-medium max-w-xs w-full" :class="titleClass">
      {{ title }}
    </h2>
    <div class="flex flex-1 items-center justify-end">
      <button
        v-if="exportButton"
        type="button"
        class="
          bg-orange-900
          border border-orange-900
          text-white-900
          rounded
          text-base
          font-medium
          px-4
          py-2.5
          hover:bg-white-900 hover:text-orange-900
        "
      >
        Export to PDF
      </button>
      <div class="flex flex-grow items-center justify-end space-x-20">
        <base-select :select-list="selectList" class="flex-shrink-0" />
        <search-input :placeholder="placeholder" big />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActionsBar",
  components: {
    "base-select": () => import("@/components/utils/Select.vue"),
    "search-input": () => import("@/components/utils/SearchInput.vue"),
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    titleClass: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    exportButton: {
      type: Boolean,
      default: () => false,
    },
    selectType: {
      type: String,
      required: true,
    },
  },
  computed: {
    /* list for dropdown */
    selectList() {
      switch (this.selectType) {
        case "books":
          return [
            "Date added",
            "Popular",
            "Name",
            "Cheap to expensive",
            "Expensive to cheap",
          ];
        case "publishers":
          return ["Name", "Number of books"];
        case "catalogs":
          return ["Date added", "Date updated", "Popular", "Name"];
        default:
          return false;
      }
    },
  },
};
</script>
